'use client';
import { useContext } from 'react';
import { LanguageContext, type LanguageContextProps } from './i18n-context';

export const useLanguage = (): LanguageContextProps =>
  useContext(LanguageContext);
